import { Flex, VStack, Text, Icon, Skeleton, Center } from '@chakra-ui/react';
import { useAppDispatch } from 'app/store';
import { addAlertAction } from 'app/store/Alerts/slice';
import { ReactComponent as CopyIcon } from 'resources/images/copy.svg';
import { copySuggestionAction } from 'app/store/Mixpanel/slice';
import { MessageBlock } from './MessageBlock';

const ResultItem = ({ keyword }: { keyword: string }) => {
  const dispatch = useAppDispatch();

  const copyLinkToClipboard = (keyword: string) => {
    navigator.clipboard.writeText(keyword);
    dispatch(addAlertAction({ message: `Keyword copied to clipboard` }));
    dispatch(copySuggestionAction());
  };

  return (
    <Flex
      w="full"
      py={1}
      px={2}
      rounded="full"
      alignItems="center"
      cursor="pointer"
      _hover={{
        bg: 'surface2',
        ' svg': {
          color: 'textBase',
        },
      }}
      onClick={() => copyLinkToClipboard(keyword)}
    >
      <Text flex={1}>{keyword}</Text>
      <Icon as={CopyIcon} color="iconBase" height={3} width={3} ml={1} />
    </Flex>
  );
};

interface ResultListProps {
  list: string[];
  errorMessage?: string;
  state: 'loading' | 'error' | 'success' | 'empty' | 'noEntry';
}

export const ResultList = ({
  list = [],
  errorMessage,
  state,
}: ResultListProps) => {
  if (errorMessage || ['error', 'empty', 'noEntry'].includes(state)) {
    return (
      <Center flex={1}>
        <MessageBlock errorMessage={errorMessage} state={state} />
      </Center>
    );
  }

  const isLoading = state === 'loading';
  return (
    <VStack flex={1} justifyContent="end" py={4} overflow="hidden" mr={-2}>
      <VStack w="full" gap={2} overflowY="auto">
        {isLoading
          ? Array.from({
              length: 50,
              // eslint-disable-next-line react/no-array-index-key
            }).map((_, index) => <Skeleton key={index} minH={6} w="full" />)
          : list.map((keyword, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <ResultItem key={index} keyword={keyword} />
            ))}
      </VStack>
    </VStack>
  );
};
